import * as Dialog from "@radix-ui/react-dialog";
import { iconsaxSearchZoomIn, iconsaxX } from "@wbly/tokens/icon";
import { Icon } from "@wbly/ui";
import type { HTMLAttributes } from "react";
import styles from "./LightboxDialog.module.css";

/**
 * Modal for previewing the provided image in a lightbox environment.
 */
export function Root({ children, ...props }: Dialog.DialogProps) {
  return <Dialog.Root {...props}>{children}</Dialog.Root>;
}

export function TriggerButton({
  className,
  ...props
}: Omit<Dialog.DialogTriggerProps, "children">) {
  return (
    <Dialog.Trigger asChild {...props}>
      <button
        className={[styles["LightboxDialog-openButton"], className].join(" ")}
      >
        <Icon href={iconsaxSearchZoomIn} size="small" />
      </button>
    </Dialog.Trigger>
  );
}

TriggerButton.displayName = "LightboxDialog.TriggerButton";

export function Content({
  children,
  className,
  ...props
}: Dialog.DialogContentProps) {
  return (
    <Dialog.Portal>
      <Dialog.Overlay className={styles["LightboxDialog-overlay"]} />
      <Dialog.Content
        className={[styles["LightboxDialog-content"], className].join(" ")}
        {...props}
      >
        <div className={styles["LightboxDialog-inner"]}>
          {children}

          <Dialog.Close asChild>
            <button className={styles["LightboxDialog-closeButton"]}>
              <Icon href={iconsaxX} />
            </button>
          </Dialog.Close>
        </div>
      </Dialog.Content>
    </Dialog.Portal>
  );
}

Content.displayName = "LightboxDialog.Content";

export function Image({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={[styles["LightboxDialog-image"], className].join(" ")}
      {...props}
    >
      {children}
    </div>
  );
}

Image.displayName = "LightboxDialog.Image";

export function Title({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLParagraphElement>) {
  return (
    <p
      className={[styles["LightboxDialog-title"], className].join(" ")}
      {...props}
    >
      {children}
    </p>
  );
}

Title.displayName = "LightboxDialog.Title";
